import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { cn } from '@antimatterhq/ui/lib/utils';

export type LinkProps = {
  size?: Size;
} & RouterLinkProps &
  React.HTMLAttributes<HTMLAnchorElement>;

export default function Link({
  children,
  className,
  size,
  ...props
}: LinkProps) {
  return (
    <RouterLink
      className={cn(
        'text-blue-600 underline-offset-4 hover:text-blue-700 hover:underline dark:text-blue-400 dark:hover:text-blue-300',
        size === 'sm' && 'text-sm',
        (!size || size === 'base') && 'text-base',
        size === 'lg' && 'text-lg',
        className,
      )}
      {...props}
    >
      {children}
    </RouterLink>
  );
}
